import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

// Create a wrapper that conditionally applies Strict Mode
const StrictModeWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Check if the current path is /api-docs
  const isApiDocs = window.location.pathname === '/api-docs';
  
  return isApiDocs ? (
    <React.Fragment>{children}</React.Fragment>
  ) : (
    <React.StrictMode>{children}</React.StrictMode>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictModeWrapper>
    <App />
  </StrictModeWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
